<p-tabView [(activeIndex)]="index" #detailTab (onChange)="getTabData()">
    <p-tabPanel header="Setting">
        <p-table [value]="settings" dataKey="id" [expandedRowKeys]="expandedRows">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 3rem;"></th>
                    <th>Name</th>
                    <th style="width: 200px;">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-setting let-expanded="expanded">
                <tr>
                    <td class="action">
                        <button type="button" pButton pRipple [pRowToggler]="setting"
                            class="p-button-text p-button-rounded p-button-plain"
                            *ngIf="setting.childInventorySettings?.length > 0 && setting.enabled"
                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                    </td>
                    <td>
                        {{setting.name}}
                    </td>
                    <td class="action">
                        @if(setting.code!='invvaluation' && setting.code!='accountingmethod' && setting.code!='accountingperiod'){
                        <p-inputSwitch [(ngModel)]="setting.enabled" (click)="confirmData(setting,$event)" 
                        disabled class="cursor-pointer"></p-inputSwitch>
                        }
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-setting>
                <ng-container *ngFor="let s of setting.childInventorySettings">
                    <tr *ngIf="setting.enabled">
                        <td></td>
                        <td>
                            <span class="p-ml-3">{{s.name}}</span>
                        </td>
                        <td class="action">
                            <p-inputSwitch [(ngModel)]="s.enabled" (onChange)="setChild(setting,s)"
                                [disabled]="isDisabled(setting,s)"></p-inputSwitch>
                            <span *ngIf="s.code == 'YesTaxOutsideStates'" class="btnBars p-ml-3"
                                (click)="showDefaultTaxSelectionDialog()" pTooltip="Edit" tooltipPosition="top"
                                style="vertical-align: baseline;">
                                <i class="pi pi-pencil"></i>
                            </span>
                            <span *ngIf="s.code == 'serialValidation'" class="btnBars p-ml-3"
                                (click)="showStageSelectionDialog(setting, s)" pTooltip="Edit" tooltipPosition="top"
                                style="vertical-align: baseline;">
                                <i class="pi pi-pencil"></i>
                            </span>
                            <span *ngIf="s.enabled && s.code == 'financialyear'" class="btnBars p-ml-3"
                                (click)="showAccPeriodDialog(s)" pTooltip="Edit" tooltipPosition="top"
                                style="vertical-align: baseline;">
                                <i class="pi pi-pencil"></i>
                            </span>
                        </td>
                    </tr>
                </ng-container>
            </ng-template>
        </p-table>
    </p-tabPanel>
    <ng-container *ngFor="let name of tabName">
        <p-tabPanel [header]="name" *ngIf="enableTracking">
            <p-table [value]="trackingList" dataKey="id">
                <ng-template pTemplate="header">
                    <tr>
                        <th id="name" style="width: 200px;">Name</th>
                        <th id="dataType" style="width: 200px;">Data Type</th>
                        <th id="dataType" style="width: 200px;" *ngIf="name=='Serial Details'">
                            Reference Field</th>
                        <th id="action" style="width: 200px;">Action</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-track>
                    <tr>
                        <td>{{track.name}}</td>
                        <td>{{track.formControlName}}</td>
                        <td *ngIf="name=='Serial Details'">
                            <p-radioButton name="referenceField" [value]="true" [(ngModel)]="track.isReference" 
                             inputId="ref1" (onClick)="updateTrackingOption(track,true,true)"
                             [disabled]="!track.enabled">
                            </p-radioButton>
                        </td>
                        <td class="action">
                            <p-inputSwitch [(ngModel)]="track.enabled" [disabled]="track.code=='field1'"
                                (onChange)="updateTrackingOption(track,true)"></p-inputSwitch>
                            <span *ngIf="track.enabled" class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"
                                (click)="getCustomFieldTypes(track)">
                                <i class="pi pi-pencil"></i>
                            </span>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
    </ng-container>
    <p-tabPanel header="Serial Batches" *ngIf="enableTracking">
        <p-table [value]="batchList" dataKey="id">
            <ng-template pTemplate="header">
                <tr>
                    <th id="name" style="width: 200px;">Name</th>
                    <th id="action" style="width: 200px;">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-batch let-index="rowIndex">
                <tr>
                    <td>{{batch.name}}</td>
                    <td class="action">
                        <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"
                            (click)="showEditBatch(batch)">
                            <i class="pi pi-pencil"></i>
                        </span>
                        <span class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top"
                            (click)="checkDeleteBatch(batch,index)">
                            <i class="pi pi-trash"></i>
                        </span>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel" *ngIf="enableTracking">
        <ng-template pTemplate="header">
            <p-menu #configMenu id="config_menu_purchase" [model]="configMenuItems" [popup]="true" appendTo="body">
            </p-menu>
            <span class="btnBars p-mr-0" (click)="configMenu.toggle($event)">
                <i class="pi pi-bars"></i>
            </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>


<!-- Default Tax selection Dialog -->
<p-dialog header="Add New Tax Code" [modal]="true" [(visible)]="displayDefaultTaxSelectionDialog"
    [style]="{width: '45vw'}" (onHide)="hideDefaultTaxSelectionDialog()">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <label>Select Default Tax</label>
                <liono-treeSelect class="border-bottom-input" [options]="allTaxRates" appendTo="body" display="comma"
                    [metaKeySelection]="false" selectionMode="single" placeholder="Select Item"
                    [(ngModel)]="selectedTax" (onNodeSelect)="onSelectTax($event)">
                </liono-treeSelect>
            </div>
        </div>
    </div>
    <p-footer>
        <button pButton (click)="hideDefaultTaxSelectionDialog()" label="Cancel" class="p-button-secondary"></button>
        <button pButton label="Save" (click)="saveDefaultTax()"></button>
    </p-footer>
</p-dialog>

<p-dialog header="Edit Tracking Option" [modal]="true" [(visible)]="displayEditOption" [style]="{width: '50vw'}"
    [baseZIndex]="10000" (onHide)="trackingOptionForm.reset();">
    <form [formGroup]="trackingOptionForm">
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-6">
                <label for="name">Name <span style="color: red;">*</span></label>
                <input type="text" pInputText formControlName="name">
                <small *ngIf="invalidData" class="p-invalid">
                    Name already exists.
                </small>
            </div>
            <div class="p-col-12 p-md-6">
                <label for="type">Data Type <span style="color: red;">*</span></label>
                <p-dropdown [options]="formControls" formControlName="formControlId" optionLabel="name"
                    placeholder="Select Data Type" appendTo="body" (onChange)="setValidation(trackingOptionForm.value)"
                    [disabled]="trackingOptionForm.controls['code'].value=='expirationChecked'"></p-dropdown>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-4">
                <div class="p-field-checkbox p-mt-3">
                    <p-checkbox formControlName="isRequired" binary="true" inputId="required"
                        [disabled]="trackingOptionForm.controls['code'].value=='serializedChecked'"></p-checkbox>
                    <label class="p-my-0" for="required">Is Required</label>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-field-checkbox p-mt-3" *ngIf="trackingOptionForm.controls['code'].value=='field1'">
                    <p-checkbox formControlName="allowDuplicate" binary="true" inputId="clear"></p-checkbox>
                    <label class="p-my-0" for="clear">Allow Duplicate</label>
                </div>
            </div>
            <div class="p-col-12 p-md-3">
                <div class="p-field-checkbox p-mt-3">
                    <p-checkbox formControlName="clearField" binary="true" inputId="clear"
                        [disabled]="trackingOptionForm.controls['code'].value=='serializedChecked'"></p-checkbox>
                    <label class="p-my-0" for="clear">Clear with every submit</label>
                </div>
            </div>
        </div>
        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-6" *ngIf="!['serializedChecked','field1'].includes(trackingOptionForm.controls['code'].value) && 
            ['Decimal','Currency','Percentage'].includes(trackingOptionForm.controls['formControlId'].value?.name)">
                <label>No. Of Decimal <span style="color: red;">*</span></label>
                <div class="p-field-checkbox">
                    <p-inputNumber formControlName="noOfDecimal" [min]="2" [max]="6"></p-inputNumber>
                </div>
            </div>
            <div class="p-col-12 p-md-6" *ngIf="trackingOptionForm.controls['formControlId'].value?.name==='Currency'">
                <label for="type">Currency <span style="color: red;">*</span></label>
                <p-dropdown [options]="allCurrencies" formControlName="currencyId" optionLabel="name"
                    placeholder="Select currency" appendTo="body" [filter]="true">
                    <ng-template let-item pTemplate="selectedItem">
                        {{item.name}} - {{item.code}}
                    </ng-template>
                    <ng-template let-obj pTemplate="item">
                        {{obj.name}} - {{obj.code}}
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <button pButton (click)="displayEditOption=false" label="Cancel" class="p-button-secondary"></button>
        <button pButton [disabled]="!trackingOptionForm.valid" (click)="updateTrackingOption(trackingOptionForm.value)"
            label="Save"></button>
    </ng-template>
</p-dialog>


<!-- Stage selection Dialog -->
<p-dialog header="Select Stage" [modal]="true" [(visible)]="displayStageSelectionDialog" [style]="{width: '45vw'}"
    (onHide)="hideStageSelectionDialog()">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <label>Select Stage</label>
                <p-dropdown [options]="allStages" [(ngModel)]="selectedStage" optionLabel="name"
                    placeholder="Select Stage" appendTo="body" optionValue="id">
                </p-dropdown>
                <div style="display: flex;padding-top: 10px;">
                    <p-checkbox [binary]="true" [(ngModel)]="restrictStageChange" inputId="ny"></p-checkbox>
                    <label for="ny" class="p-ml-2">Serial No. Required</label>
                </div>
            </div>
        </div>
    </div>
    <p-footer>
        <button pButton (click)="hideStageSelectionDialog()" label="Cancel" class="p-button-secondary"></button>
        <button pButton label="Save" (click)="saveStage()"></button>
    </p-footer>
</p-dialog>

<!-- Stage selection Dialog -->
<p-dialog header="Select Accounting Period" [modal]="true" [(visible)]="displayAccontingPeriod" [style]="{width: '45vw'}"
    (onHide)="accPeriodForm.reset()">
    <form [formGroup]="accPeriodForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-6">
                    <label>Start Month <span style="color: red;">*</span></label>
                    <p-dropdown [options]="months" formControlName="startMonthId" optionLabel="label"
                        placeholder="Select month" appendTo="body" optionValue="value" (onChange)="setEndMonth()">
                    </p-dropdown>
                </div>
                <div class="p-col-6">
                    <label>End Month</label>
                    <p-dropdown [options]="months" formControlName="endMonthId" optionLabel="label"
                        placeholder="Select month" appendTo="body" optionValue="value">
                    </p-dropdown>
                </div>
            </div>
        </div>
    </form>
    <p-footer>
        <button pButton (click)="displayAccontingPeriod=false;" label="Cancel" class="p-button-secondary"></button>
        <button pButton label="Save" [disabled]="!accPeriodForm.valid" (click)="saveAccountingPeriod(accPeriodForm.getRawValue())"></button>
    </p-footer>
</p-dialog>

<!--Add/Edit Batch-->
@if(displayBatchForm){
    <app-addedit-batch [displayBatchForm]="displayBatchForm" [batchList]="batchList" [batchGroup]="batchGroup"
    [addFlag]="addFlag" [batchData]="batchData" (onClose)="closeBatchDialog()"
    (onSaveBatch)="onSaveBatch()"></app-addedit-batch>
}